"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var brandCenter;
        (function (brandCenter) {
            var screenShots;
            (function (screenShots) {
                class InitArgs {
                    constructor() {
                        this.brandCenterDeleteScreenShot = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                }
                screenShots.init = init;
                function addEvents() {
                    $('.btnAddScreenshot').off().on('click', function (event) {
                        event.preventDefault();
                        $(this).hide();
                        $(this).closest('.image-col').find('.fileinput.fileinput-new').removeClass('hide');
                    });
                    $('.btn-fileupload-deleteFile').click(function (event) {
                        event.preventDefault();
                        if ($(this).attr('disabled') || event.target.hasAttribute('disabled'))
                            return;
                        const currentImageCol = $(this).closest('.image-col');
                        appn.dialog.confirm({
                            modalColor: 'modal-danger',
                            title: appn.strings.deleteTitle,
                            message: T('This screenshot will be permanently deleted.<br />Are you sure you want to delete this screenshot?<br /><br />Click <b>OK</b> to delete.'),
                            buttons: {
                                confirm: {
                                    label: '<span>' + T('OK') + '</span>',
                                    className: 'btn-success'
                                }
                            },
                            className: appn.emptyString,
                            isDeleteAction: true,
                            callback: function (result) {
                                if (result) {
                                    appn.dialog.showLoading();
                                    const data = {
                                        deviceOs: currentImageCol.data('deviceos'),
                                        formFactor: currentImageCol.data('formfactor'),
                                        screenytIndexToDelete: currentImageCol.data('screenytindextodelete'),
                                        providerId: currentImageCol.data('providerid')
                                    };
                                    $.ajax({
                                        headers: appn.verifyHeader,
                                        url: _initArgs.brandCenterDeleteScreenShot,
                                        data: data,
                                        success: function (jqXHR, textStatus, errorThrown) {
                                            appn.location.reloadCurrentPage();
                                        },
                                        contentType: 'application/x-www-form-urlencoded; charset=utf-8',
                                        dataType: 'json',
                                        type: 'POST',
                                        cache: false,
                                        error: function (jqXHR, textStatus, errorThrown) {
                                            appn.dialog.hideLoading();
                                            if (!errorThrown || textStatus === 'parsererror')
                                                errorThrown = appn.strings.errorRetrievingData;
                                            appn.toast.notify(appn.toast.Type.error, errorThrown);
                                        }
                                    });
                                }
                            }
                        });
                    });
                }
            })(screenShots = brandCenter.screenShots || (brandCenter.screenShots = {}));
        })(brandCenter = views.brandCenter || (views.brandCenter = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
